export default "__VITE_ASSET__BMNlDYap__"